// ─────────────────────────────────────────────────────────────────────────────
// graphSource — the ONE contract between the graph engine and where data comes
// from.
//
// THIS INTERFACE IS THE REASON THE BLAST RADIUS CAN ARRIVE LATER WITHOUT A
// RENDERER REWRITE. Everything upstream of it — files, silos, the registry, the
// topology walk, an HTTP endpoint that does not exist yet — is the source's
// problem. Everything downstream consumes records and patches and nothing else.
//
// G0/G1 use StaticRexyGraphSource (dev/graphLabSeed.ts), whose ids all begin
// `lab:` so a synthetic node can never be mistaken for a real one. G2 adds
// LiveRexyGraphSource against core/agent_registry.py + core/harness_topology.py
// — the box's own topology, never a hand-drawn map, because a drawn map is
// correct the day it is written and silently wrong afterwards.
// ─────────────────────────────────────────────────────────────────────────────

import { RexyGraphNodeRecord, RexyGraphPatch, RexyGraphSnapshot } from './graphTypes';

export interface RexyGraphSource {
  /** The root snapshot: City Hall, the domain shells, and their edges. */
  loadRoot(): Promise<RexyGraphSnapshot>;

  /** Hydrate deeper structure on demand. `depth` is levels below `parentId`. */
  loadChildren(parentId: string, depth: number): Promise<RexyGraphPatch>;

  /** Locate nodes that may not be hydrated yet (G1 wires this to the overlay). */
  search(query: string, limit?: number): Promise<RexyGraphNodeRecord[]>;

  /** Optional live channel. Returns its own unsubscribe. */
  subscribe?(callback: (patch: RexyGraphPatch) => void): () => void;
}

/**
 * The prefix every synthetic lab id carries. Exported so the lab source, the
 * dev overlay and any future assertion all read the SAME string rather than
 * three copies of a literal that could drift apart.
 */
export const LAB_ID_PREFIX = 'lab:';

export function isLabId(id: string): boolean {
  return id.indexOf(LAB_ID_PREFIX) === 0;
}
